






























import Vue, { PropOptions } from 'vue';
import {NOC, moment} from '@/class';

import GadgetFrame, {IFrame, CFrame} from './GadgetFrame.vue';
import SampleGadgetBase from './SampleGadgetBase.vue';
import BasicGadget from './BasicGadget.vue';
import SelectBox, {IOption} from '@/components/util/SelectBox.vue';

// 通信
import API from '@/api/common';
import * as models from '@/class/models/views/graph';

const GRAPH_HW = 248;

export default Vue.extend({
  name: 'SampleGadget',
  components: { SampleGadgetBase, BasicGadget },
  props: {
    title: String,
    materials: Object,
    baseFrameData: Object as PropOptions<IFrame>,
    gadgetData: Object as PropOptions<models.IGadget>,
    w: Number,
    h: Number,
    dashBoard: {
      type: Boolean,
      default: false,
    },
    plasticCase: {
      type: Boolean,
      default: false,
    },
    resized: Boolean,
  },
  data() {
    return {
      sampleFLag: true,
      defaultGadgetData: new models.CGadget(),
    };
  },
  watch: {
    defaultGadgetData: {
      deep: true,
      async handler() {
        this.defaultGadgetData.gadgetID = this.gadgetData.gadgetID;
        (this.defaultGadgetData as models.IGadget).default = true;
      },
    },
  },
  async mounted() {

    this.defaultGadgetData.data = {
      now: {},
      graph: this.gadgetData.data.graph,
      materials: this.gadgetData.data.materials,
      values: this.gadgetData.data.values,
      groups: [],
    };
    if (this.gadgetData.options) {
      this.defaultGadgetData.options = this.gadgetData.options;
    }
    const api = new API();
    const res = await api.post<models.IDomain, IOption[]>('gadget/ct1', NOC.MATERIAL.V3.MATERIALS[0]);
    // console.log('res', res);
    if (res.result) {
      // データがある場合
      if (res.data.length > 0) {
        // console.log(this.gadgetData);
        this.defaultGadgetData.title = this.gadgetData.title;
        this.defaultGadgetData.comment = this.gadgetData.comment;
        this.sampleFLag = false;
      }
    }
  },
  methods: {
  },
});
